module.exports = __webpack_public_path__ + "img/facebook-logo.059774ca.png";